export const disableSpaceBar = (values) => {
  if (!values.target) return
  if (values.keyCode === 32) {
    const selectionStart = values?.target?.selectionStart ?? 0
    const selectionEnd = values?.target?.selectionEnd ?? 0
    const value = values?.target?.value ?? ''
    if (
      (selectionStart === 0 && selectionEnd === 0) ||
      (selectionStart === value.length && selectionEnd === value.length)
    ) {
      return values.preventDefault()
    } else return
  }
}
